// constants
import { BannerActionTypes } from "./constants";

export interface BannerActionType {
  type:
    | BannerActionTypes.API_RESPONSE_SUCCESS
    | BannerActionTypes.API_RESPONSE_ERROR
    | BannerActionTypes.UPDATE_BANNER
    | BannerActionTypes.CREATE_BANNER
    | BannerActionTypes.GET_BANNER
    | BannerActionTypes.DELETE_BANNER_IMAGE
    | BannerActionTypes.DELETE_BANNER;
  payload: {} | string;
}

interface bannerDetails {
  id: string;
  heading: string;
  heading_ar: string;
  non_animate_text: string;
  non_animate_text_ar: string;
  animate_text: string;
  animate_text_ar: string;
  para: string;
  para_ar: string;
  image: File[] | null;
}

// common success
export const bannerApiResponseSuccess = (
  actionType: string,
  data: bannerDetails | {}
): BannerActionType => ({
  type: BannerActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const bannerApiResponseError = (
  actionType: string,
  error: string
): BannerActionType => ({
  type: BannerActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createBanner = (
  heading: string,
  heading_ar: string,
  non_animate_text: string,
  non_animate_text_ar: string,
  animate_text: string,
  animate_text_ar: string,
  para: string,
  para_ar: string,
  image: File[] | null
): BannerActionType => ({
  type: BannerActionTypes.CREATE_BANNER,
  payload: {
    image,
    heading,
    heading_ar,
    non_animate_text,
    non_animate_text_ar,
    animate_text,
    animate_text_ar,
    para,
    para_ar,
  },
});

export const getBanner = (): BannerActionType => ({
  type: BannerActionTypes.GET_BANNER,
  payload: {},
});

export const deleteBanner = (id: string): BannerActionType => ({
  type: BannerActionTypes.DELETE_BANNER,
  payload: { id },
});

export const deleteBannerImages = (ids: string[]): BannerActionType => ({
  type: BannerActionTypes.DELETE_BANNER_IMAGE,
  payload: { ids },
});

export const updateBanner = (
  id: string,
  heading: string,
  heading_ar: string,
  non_animate_text: string,
  non_animate_text_ar: string,
  animate_text: string,
  animate_text_ar: string,
  para: string,
  para_ar: string,
  image: File[] | null
): BannerActionType => ({
  type: BannerActionTypes.UPDATE_BANNER,
  payload: {
    id,
    image,
    heading,
    heading_ar,
    non_animate_text,
    non_animate_text_ar,
    animate_text,
    animate_text_ar,
    para,
    para_ar,
  },
});
